import React from 'react'
import classes from './Icon.module.scss'

interface Props {
  iconName: string
  color?: string
  size?: number
}

const Icon = (props: Props): JSX.Element => (
  <div
    className={`icon-${props.iconName} panicon ${classes.icon}`}
    style={{
      color: props.color ? props.color : 'inherit',
      fontSize: props.size ? props.size : 'inherit'
    }}
  />
)

export default Icon
